import React from 'react'
import { useField } from 'formik'
import { FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup } from '@mui/material'
import { useAppTranslations } from '../../utils/hooks/useAppTranslations'
import { StyledFormLabel } from './styled'
import { InputOptions } from './Options'

export interface RadioButtonsGroupProps {
  name: string
  label: string
  options?: InputOptions[]
  onMouseLeave?: () => void
  compact?: boolean
}

export interface RadioButtonProps {
  value: string | number | boolean
  label: string
  name: string
}

const RadioButton: React.FC<RadioButtonProps> = ({ value, label, name }) => {
  const t = useAppTranslations()
  const stringLabel: string = t(label)
  const [, , helpers] = useField({ name })
  const { setValue } = helpers
  return <FormControlLabel control={<Radio />} label={stringLabel} onChange={() => setValue(value)} value={value} />
}

const RadioButtonsGroup: React.FC<RadioButtonsGroupProps> = ({
  name,
  label,
  options = [],
  onMouseLeave,
  compact = false,
}) => {
  const t = useAppTranslations()
  const [, meta] = useField({ name })

  const { value } = meta
  const hasError = Boolean(meta.touched && meta.error)
  const helperText = meta.error && hasError ? t(meta.error) : ' '

  const renderRadio = options.map((option, index) => (
    <RadioButton key={index} value={option.value} label={option.label} name={name} />
  ))

  return (
    <FormControl component="fieldset" error={hasError} onMouseLeave={onMouseLeave} sx={compact ? { mt: 0 } : undefined}>
      {!compact && <StyledFormLabel error={hasError}>{t(label)}</StyledFormLabel>}
      <RadioGroup row aria-label="gender" name={name} value={value}>
        {renderRadio}
      </RadioGroup>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  )
}
export default RadioButtonsGroup
